import Promise from 'bluebird';
import Validate from './Validate';

var PHONE_CODES = [
    '301','302','336','341','342','343','345','346','347','349','351','352','353','365','381','382','383','384','385','388','390','391','394','395',
    '401','411','413','415','416','421','423','424','426','427','471','472','473','474','475','481','482','483','484','485','486','487','491','492','493','494','495','496','498','499',
    '800','801','802','803','804','805','806','807','808','809','811','812','813','814','815','816','817','818','820','821','831','833','834','835','836','841','842','843','844','845','846','847','848','851','855','861','862','863','865','866','867','869','871','872','873','877','878','879',
    '900','901','902','903','904','905','906','908','909',
    '910','911','912','913','914','915','916','917','918','919',
    '920','921','922','923','924','925','926','927','928','929',
    '930','931','932','933','934','936','937','938','939',
    '941',
    '950','951','952','953','954','955','956','958',
    '960','961','962','963','964','965','966','967','968','969',
    '970','971','977','978',
    '980','981','982','983','984','985','986','987','988','989',
    '991','992','993','994','995','996','997','999'
];

class Form {
    constructor(obj) {
        this.form = obj;
        this.uri = '/api/form/';
    }

    getValues() {
        if (! this.values) {
            this.values = {};

            let serialize = this.form.serializeArray()
            for (let i in serialize)
                this.values[serialize[i].name] = serialize[i].value;
        }

        return this.values;
    }

    isValid() {
        this.hideErrors();

        this.errors = {};
        
        // проверка phone
        if (this.form.find('[name="phone"]').length) {
            let value = this.getValues().phone;

            if (! Validate.phone(value))
                this.errors.phone = 'Укажите корректный телефон';
        }

        // Проверка login
        if (this.form.find('[name="login"]').length) {
            let value = this.getValues().login;

            if (! Validate.login(value))
                this.errors.login = 'Логин указан некорректно. необходимо указать не менее 2 символов. Допустимо использовать только латинские буквы, цифры, \n' +
                    'знак подчеркивания («_»), точку («.»), минус («-»)';
        }

        // Проверка email
        if (this.form.find('[name="email"]').length) {
            let value = this.getValues().email;

            if (! Validate.email(value))
                this.errors.email = 'Укажите корректный Email';
        }

        // Проверка password
        if (this.form.find('[type="password"]').length) {
            for (let i = 0, l = this.form.find('[type="password"]').length; i < l; i++) {
                let el = this.form.find('[type="password"]').eq(i);
                let value = el.val();

                if (! Validate.password(value))
                    this.errors[el.attr('name')] = 'Пароль должен быть не менее 8 символов';
            }
        }

        // Проверка kladr
        if (this.form.find('.kladr-error').length) {
            for (let i = 0, l = this.form.find('.kladr-error').length; i < l; i++) {
                let el = this.form.find('.kladr-error').eq(i);
                el.removeClass('kladr-error');
                this.errors[el.attr('name')] = 'Данные указаны некорректно';
            }
        }

        // Проверка на required
        for (let i = 0; i < this.form.find('[required]').length; i++) {
            let elem = this.form.find('[required]').eq(i);
            
            if (elem.attr('name') === 'agreement' && !elem.prop('checked')) {
                $("label[for='agreement'][generated='true']").remove()
                elem.parent('.form__checkbox').after('<label for="agreement" generated="true" class="error error_agreement">Поле обязательно для заполнения</label>')
                this.errors[elem.attr('name')] = '';
            }

            if (elem.val() == '') {
                this.errors[elem.attr('name')] = 'Поле обязательно для заполнения';
            }
        }

        return Object.keys(this.errors).length == 0;
    }

    url(value) {
        if (! value)
            return this.uri;

        this.uri = value;

        return this;
    }

    send(ok, err) {
        $.ajax({
            type: 'POST',
            url: this.url() + (this.getValues().action || 'simple'),
            data: this.form.serialize(),
            success: ok,
            error: err
        });
    }

    clear() {
        this.form.find('input:not([type="hidden"]):not([type="submit"]), select, textarea').val('');
        this.form.find('input, select, textarea').each(function() {
            $(this).next().text('');
        });
    }

    hideErrors() {
        for (name in this.getValues())
            this.hideError(name)
    }

    hideError(name) {
        this.form.find('[name="' + name + '"]').removeClass('error');
        this.form.find('label[for="' + name + '"].error').remove();
    }

    showError(name, msg) {
        this.form.find('[name="' + name + '"]').addClass('error');
        if (this.form.find('[name="' + name + '"]').next('label.error[for="' + name + '"]').length)
            this.form.find('[name="' + name + '"]').next().html(msg);
        else
            this.form.find('[name="' + name + '"]').after('<label for="' + name + '" generated="true" class="error">' + msg + '</label>');
    }
}

export default Form;